import {flow, types} from 'mobx-state-tree';
import TeamSettingsModel from '../TeamSettingsModel';
import * as api from '../../services/api';
import {StaahTeamSettingModel} from '../TeamSettingsModel';

export const TeamSettingsDetailModel = types
  .model('TeamSettingsDetail', {
    isLoading: types.optional(types.boolean, false),
    isStaahLoading: types.optional(types.boolean, false),
    teamSetting: types.maybe(TeamSettingsModel),
    staahTeamSetting: types.maybe(StaahTeamSettingModel),

    // Update staah account
    isEditingStaahAccount: types.optional(types.boolean, false),
    hotelId: types.optional(types.string, ''),
    username: types.optional(types.string, ''),
    password: types.optional(types.string, '')
  })
  .actions(self => {
    return {
      getTeamSettings: flow(function*(teamId: number) {
        self.isLoading = true;
        const response = yield api.getTeamSettings(teamId);

        if (response.status === 200 && response.data) {
          self.teamSetting = response.data;
          self.isLoading = false;
        }
      }),
      getStaahSetting: flow(function*(teamId: number) {
        self.isStaahLoading = true;
        try {
          const response = yield api.getStaahTeamSetting(teamId);
          if (
            response.status === 200 &&
            response.data &&
            response.data.staahSetting
          ) {
            self.staahTeamSetting = response.data.staahSetting;
            self.isStaahLoading = false;
          } else {
            self.isStaahLoading = false;
          }
        } catch (err) {
          self.isStaahLoading = false;
        }
      }),
      // tslint:disable-next-line
      updateStaahAccount: flow(function*(teamId: number, callback: any) {
        if (!self.hotelId || !self.username || !self.password) {
          callback('error', 'Please full fill this form');
          return;
        }

        try {
          const response = yield api.updateStaahTeamSetting(teamId, {
            hotelId: self.hotelId,
            username: self.username,
            password: self.password
          });

          if (
            response.status === 200 &&
            response.data &&
            response.data.staahSetting
          ) {
            self.staahTeamSetting = response.data.staahSetting;
            self.isStaahLoading = false;
          } else {
            self.isStaahLoading = false;
          }
        } catch (err) {
          self.isStaahLoading = false;
        }
      }),
      toggleEditingStaahAccount: () => {
        self.isEditingStaahAccount = !self.isEditingStaahAccount;
      },
      onChangeHotelId: (value: string) => {
        self.hotelId = value;
      },
      onChangeUsername: (value: string) => {
        self.username = value;
      },
      onChangePassword: (value: string) => {
        self.password = value;
      }
    };
  });

export type TeamSettingsDetailModelType = typeof TeamSettingsDetailModel.Type;

export default TeamSettingsDetailModel;



// WEBPACK FOOTER //
// ./src/models/TeamSettingDetailModel/TeamSettingDetailModel.ts